import type { PlataformaDeMidia, SaldoDaConta, SituacaoDoSaldo } from "@base/contracts";

/** "Precisa de acao" junta as situacoes que pedem a Monte agir agora. */
export type FiltroDeSituacao = "todas" | "precisa-de-acao" | SituacaoDoSaldo;

export type FiltroDeSaldos = {
  readonly busca: string;
  readonly plataforma: "todas" | PlataformaDeMidia;
  readonly situacao: FiltroDeSituacao;
  /** Id da clinica, "sem-clinica" ou "todas". */
  readonly clinica: string;
  readonly comInativas: boolean;
};

export const FILTRO_INICIAL: FiltroDeSaldos = {
  busca: "",
  plataforma: "todas",
  situacao: "todas",
  clinica: "todas",
  comInativas: false,
};

const PRECISA_DE_ACAO: ReadonlySet<SituacaoDoSaldo> = new Set(["pagamento-pendente", "abaixo-do-minimo"]);

const normalizar = (texto: string) =>
  texto
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();

/** O filtro esta diferente do inicial (para mostrar "Limpar filtros"). */
export function filtroAtivo(filtro: FiltroDeSaldos): boolean {
  return (
    filtro.busca.trim() !== "" ||
    filtro.plataforma !== "todas" ||
    filtro.situacao !== "todas" ||
    filtro.clinica !== "todas"
  );
}

/**
 * Contas que passam no filtro. Inativas ficam fora salvo quando pedidas ou
 * quando a situacao escolhida e justamente "inativa". A busca acha a conta
 * pelo nome, pelo id (com ou sem hifen) e pelo nome da clinica.
 */
export function filtrarSaldos(
  contas: readonly SaldoDaConta[],
  filtro: FiltroDeSaldos,
  nomeDoCliente: (clienteId: string) => string | null,
): readonly SaldoDaConta[] {
  const termo = normalizar(filtro.busca.trim());
  const termoDigitos = termo.replace(/\D/g, "");
  return contas.filter((conta) => {
    if (conta.situacao === "inativa" && !filtro.comInativas && filtro.situacao !== "inativa") return false;
    if (filtro.plataforma !== "todas" && conta.plataforma !== filtro.plataforma) return false;
    if (filtro.situacao === "precisa-de-acao" && !PRECISA_DE_ACAO.has(conta.situacao)) return false;
    if (filtro.situacao !== "todas" && filtro.situacao !== "precisa-de-acao" && conta.situacao !== filtro.situacao) {
      return false;
    }
    if (filtro.clinica === "sem-clinica" && conta.clientes.length > 0) return false;
    if (filtro.clinica !== "todas" && filtro.clinica !== "sem-clinica" && !conta.clientes.includes(filtro.clinica)) {
      return false;
    }
    if (termo === "") return true;
    const clinicas = conta.clientes.map((id) => nomeDoCliente(id) ?? "").join(" ");
    return (
      normalizar(`${conta.nome} ${clinicas}`).includes(termo) ||
      (termoDigitos.length > 0 && conta.contaId.replace(/\D/g, "").includes(termoDigitos))
    );
  });
}
